import React from 'react';
import { useNavigate } from 'react-router-dom';
type SuccessProps = {
  setStatus?: () => void;
  title?: string;
  buttonTitle?: string;
  url?: string | number;
  nameUrl?: string;
};

const Success: React.FC<SuccessProps> = ({
  setStatus,
  title,
  buttonTitle,
  url,
  nameUrl,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      <img
        className={'leave_request_header'}
        src="/assets/header_background.svg"
        alt="background"
      />
      <div style={{ marginLeft: '40%', position: 'absolute' }}>
        <img src="assets/success.svg" alt="success" />
        <h2 style={{ marginLeft: '15px' }}>{title}</h2>
        <button
          onClick={setStatus}
          style={{
            margin: '30px 10px 0px 0px ',
            color: 'white',
            background: '#3076DD',
            width: '300px',
            height: '60px',
            borderRadius: '20px',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {buttonTitle}
        </button>
        <div
          style={{
            display: 'flex',
            marginLeft: '40px',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <img src="icons/arrow_right.svg" alt="arrow" />
          <div
            onClick={() => navigate(`${url}`)}
            style={{ color: '#E02C2C', cursor: 'pointer' }}
          >
            {nameUrl}
          </div>
        </div>
        {/* <img
        style={{ position: 'absolute' }}
        src="assets/baloon.svg"
        alt="baloon"
      /> */}
      </div>
    </div>
  );
};

export default Success;
